import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import ClaimAppealPageComponent from './ClaimAppealPage';
import { getClaimAllDetails,get,getClaimJSONView} from '../../store/actions/claimAnalysis';
import {  } from '../../store/api/claimAnalysis';


const selectClaimNumber = (props) => props.match.params.claimNumber;
const selectClaimId = (props) => props.match.params.claimId;
const selectData = (state) => state?.claimAnalysis?.jsonView;
export const ClaimAppealPage = connect(
    (state,props) => {    
        return {
            claimData: selectData(state),                           
            claimNumber:selectClaimNumber(props),
            claimId:selectClaimId (props)        
        };  
    },
    (dispatch) => ({
        actions: bindActionCreators({
            getClaimAllDetails: getClaimAllDetails,
            get:get,
            getClaimData:getClaimJSONView,
        }, dispatch)
    })
)(injectIntl(ClaimAppealPageComponent));